<template>
	<v-card>

		<v-toolbar :dark="dark" dense :color="color">
			<v-toolbar-title>
				<slot name="title"></slot>
			</v-toolbar-title>
			<div class="flex-grow-1"></div>

			<v-toolbar-items>
				<slot name="bar-actions"></slot>
			</v-toolbar-items>
		</v-toolbar>

		<v-card-text class="pa-2">
			<v-row>
				<v-col>
					<slot></slot>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
	export default {
		name: "c-card",
		props: {
			color: {type: String, default: "blue"},
			dark: {type: Boolean, default: true}
		},
		components: {},
		data() {
			return {};
		},
		computed: {},
		methods: {},
		watch: {},
		created() {
		},
		mounted() {
		},
		updated() {
		},
		destroyed() {
		}
	};
</script>

<style scoped>

</style>
